import { analyticsUtils } from './analytics-utils';
import {
	TGABlockImpression,
	TGAClickButton,
	TGAClickProduct,
	TGAImpressions,
	TGAPageViewData,
	TGAPromoClick,
	TGAPromoView,
	TGAShow,
} from './types';

const productBelong = 'LeroyMerlinServices';

export const GAPageViewEvent = (data: TGAPageViewData) => {
	analyticsUtils.sendEvent('GA:pageview', {
		pageType: 'ServicePage', // тип страницы
		platform: 'react',
		...data,
	});
};

export const GAClickButton = (data: TGAClickButton) => {
	analyticsUtils.sendEvent('GA:clickButton', {
		elementType: 'button',
		...data,
	});
};

export const GAClickProduct = (data: TGAClickProduct) => {
	analyticsUtils.sendEvent('GA:clickProduct', {
		elementType: 'product',
		productBelong,
		...data,
	});
};

export const GAPromoClick = (data: TGAPromoClick) => {
	analyticsUtils.sendEvent('GA:promoClick', {
		elementType: 'banner',
		...data,
	});
};

export const GAPromoView = (data: TGAPromoView) => {
	analyticsUtils.sendEvent('GA:promoView', {
		elementType: 'banner',
		...data,
	});
};

export const GAImpressions = (data: TGAImpressions) => {
	analyticsUtils.sendEvent('GA:impressions', {
		elementType: 'page',
		productBelong,
		...data,
	});
};

export const GABlockImpression = (data: TGABlockImpression) => {
	analyticsUtils.sendEvent('GA:blockImpression', {
		elementType: 'block',
		...data,
	});
};

export const GAShow = (data: TGAShow) => {
	analyticsUtils.sendEvent('GA:show', {
		elementType: 'block',
		...data,
	});
};
